import React from 'react'
import { compose, } from 'recompose'
import { Button, Icon } from 'semantic-ui-react'
import Alert from 'components/modals/Alert'
import { withCollection } from './withCollection'
import { withSorter } from './withSorter'
import { withModalSubmit } from './withModalSubmit'

export const withSortableCollection = ({ ...options }) => (WrappedComponent) => {
  const SortableComponent = withSorter()(WrappedComponent)
  return compose(
    withCollection({ ...options }),
    withModalSubmit(),
  )(
    ({
      collection,
      onUpdate,
      onRawChange,
      onAddToLast,
      onUpdateItemByIndex,
      onUpdateStringByIndex,
      onReplaceItemByIndex,
      onDeleteByIndex,
      openSubmitModal,
      onToggleSubmitModal,
      onCloseSubmitModal,
      submitModalAction,
      wrapperStyle,
      renderAddButton,
      hideAddButton,
      ...props
    }) => {
      const {
        buttonProps = {},
        buttonLabel = 'Click to Add',
      } = options
      const createAddButton = () => (
        renderAddButton ? (
          renderAddButton({ onAddToLast })
        ) : (
          <Button
            icon
            style={{ width: '100%', marginTop: 20 }}
            onClick={onAddToLast}
            {...buttonProps}
          >
            <Icon name="plus" /> {buttonLabel}
          </Button>
        )
      )
      return (
        <div style={wrapperStyle}>
          <SortableComponent
            {...props}
            collection={collection}
            onDeleteByIndex={(index) => onToggleSubmitModal(() => onDeleteByIndex(index))}
            onUpdateItemByIndex={onUpdateItemByIndex}
            onUpdateStringByIndex={onUpdateStringByIndex}
            onReplaceItemByIndex={onReplaceItemByIndex}
            onUpdate={onUpdate}
            onRawChange={onRawChange}
          />
          {hideAddButton ? null : createAddButton()}
          <Alert
            open={openSubmitModal}
            content={'You are about to delete this item, Are u sure ?'}
            onCancel={onCloseSubmitModal}
            onSubmit={submitModalAction}
          />
        </div>
      )
    },
  )
}


// WEBPACK FOOTER //
// ./src/hocs/bases/withSortableCollection.js